import { useState } from 'react';
import React from 'react';

import MainHeader from '../../ui-components/MainHeader';
import TopHeaderUi from '../../ui-components/TopHeaderUi';

import MaterialRequest from './MaterialReqisitionTable';
import MaterailRequestModal from './MaterailRequestModal';
import BuyerRequestModal from './BuyerRequestModal';
import MaterialRequirementModal from './MaterialRequirementModal';
import AutherziationPage from './AutherziationPage';
import UpdateByerEtdModal from './UpdateByerEtdModal';

const MaterialWrapper = () => {
	const [activeTab, setActiveTab] = useState('Material Request');
	const uiTabs = [
		'Material Request',
		'Material Request Modal',
		'Buyer Request Modal',
		'Material Requirement Modal',
		'Authorization Page',
		'Update Byer Etd Modal'
	];

	const renderComponents = () => {
		switch (activeTab) {
			case 'Material Request':
				return <MaterialRequest />;
			case 'Material Request Modal':
				return <MaterailRequestModal />;
			case 'Buyer Request Modal':
				return <BuyerRequestModal />;
			case 'Material Requirement Modal':
				return <MaterialRequirementModal />;
			case 'Authorization Page':
				return <AutherziationPage />;
			case 'Update Byer Etd Modal':
				return <UpdateByerEtdModal />;
		}
	};

	return (
		<div className="content">
			<MainHeader />
			<div className="wraper container-fluid dashboard-container bg-gray">
				<TopHeaderUi activeTab={activeTab} setActiveTab={setActiveTab} tabs={uiTabs} />
				{renderComponents()}
			</div>
		</div>
	);
};

export default MaterialWrapper;
